/* ============================================
   SOMA — THEME JAVASCRIPT
   ============================================ */

(function() {
  'use strict';

  /* --- Header Scroll Effect --- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Mobile Menu Toggle --- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav-overlay');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('is-active');
      mobileNav.classList.toggle('is-open');
      document.body.style.overflow = mobileNav.classList.contains('is-open') ? 'hidden' : '';
    });

    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        menuToggle.classList.remove('is-active');
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* --- FAQ Accordion --- */
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');

        // Close all
        faqItems.forEach(i => i.classList.remove('is-open'));

        // Open clicked (if wasn't open)
        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    }
  });

  /* --- Cart Drawer --- */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartToggles = document.querySelectorAll('.cart-toggle, [data-open-cart]');
  const cartClose = document.querySelector('.cart-drawer-close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartToggles.forEach(toggle => toggle.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* --- Add to Cart (Ajax) --- */
  function addToCart(variantId, quantity) {
    const data = {
      items: [{
        id: parseInt(variantId),
        quantity: parseInt(quantity) || 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(() => {
      updateCartDrawer();
      openCart();
    })
    .catch(error => console.error('Add to cart error:', error));
  }

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCartItems(cart);
        updateCartCount(cart.item_count);
      })
      .catch(error => console.error('Cart fetch error:', error));
  }

  function updateCartCount(count) {
    const cartCounts = document.querySelectorAll('.cart-count');
    cartCounts.forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  // Capture upsell HTML from Liquid-rendered DOM before first re-render
  let upsellHtmlCache = '';
  let upsellProductIdCache = 0;
  const initUpsell = document.querySelector('.cart-upsell[data-upsell-variant]');
  if (initUpsell) {
    upsellHtmlCache = initUpsell.outerHTML;
    upsellProductIdCache = parseInt(initUpsell.dataset.upsellProductId) || 0;
  }

  /* --- Garantie-Leiste: „Teste bis zum …“ = heute + 30 Tage, in Worten --- */
  function updateGuaranteeDates() {
    const lang = document.documentElement.lang || 'de';
    document.querySelectorAll('[data-guarantee-date]').forEach(el => {
      const days = parseInt(el.dataset.days, 10) || 30;
      const date = new Date();
      date.setDate(date.getDate() + days);
      try {
        el.textContent = date.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
      } catch (e) {
        el.textContent = date.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
      }
    });
  }
  updateGuaranteeDates();

  /* --- Duo-Hinweis je Warenkorb-Position ---
     Leitet aus dem automatischen Rabatt (fester Betrag je Stück, z. B. 14,95 €) ab, wie viele
     Duo-Sets in der Position stecken: „Duo-Set: 2 Stück für 74,95 €“ + „1 × einzeln für 44,95 €“,
     bzw. bei zwei verschiedenen Gabeln an der rabattierten: „Im Duo-Set: 30,00 € statt 44,95 €“. */
  function duoNote(item) {
    const allocations = (item.line_level_discount_allocations || []).filter(a => {
      const app = a.discount_application || {};
      return app.type === 'automatic' && app.value_type === 'fixed_amount' && parseFloat(app.value) > 0;
    });
    if (!allocations.length) return '';
    const perUnit = Math.round(parseFloat(allocations[0].discount_application.value) * 100);
    const amount = allocations.reduce((sum, a) => sum + (a.amount || 0), 0);
    const pairs = Math.round(amount / perUnit);
    const unit = item.original_price;
    if (!pairs || !unit) return '';
    const s = window.somaStrings || {};
    const fill = (tpl, map) => Object.keys(map).reduce((txt, k) => txt.split('[' + k + ']').join(map[k]), tpl || '');
    if (item.quantity >= pairs * 2) {
      const duoPrice = formatMoney(unit * 2 - perUnit);
      let text = pairs === 1
        ? fill(s.duoPair || 'Duo-Set: 2 Stück für [price]', { price: duoPrice })
        : fill(s.duoPairs || '[count] × Duo-Set: je 2 Stück für [price]', { count: pairs, price: duoPrice });
      const singles = item.quantity - pairs * 2;
      if (singles > 0) {
        text += '<br>' + fill(s.duoSingle || '+ [count] × einzeln für [price]', { count: singles, price: formatMoney(unit) });
      }
      return text;
    }
    const second = fill(s.duoSecond || 'Im Duo-Set: [price] statt [original]', { price: formatMoney(unit - perUnit), original: formatMoney(unit) });
    return (pairs > 1 ? pairs + ' × ' : '') + second;
  }

  function renderCartItems(cart) {
    const cartBody = document.querySelector('.cart-drawer-body');
    const cartFooter = document.querySelector('.cart-drawer-footer');
    document.querySelectorAll('.cart-drawer [data-cart-guarantee]').forEach(el => {
      el.hidden = cart.items.length === 0;
    });
    if (!cartBody) return;

    if (cart.items.length === 0) {
      cartBody.innerHTML = `
        <div class="cart-empty">
          <div style="margin-bottom: 16px; opacity: 0.3;"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>
          <p>${window.somaStrings?.cartEmpty || 'Dein Warenkorb ist leer'}</p>
          <a href="/" class="btn btn--accent">${window.somaStrings?.continueShopping || 'Weiter einkaufen'}</a>
        </div>`;
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    if (cartFooter) cartFooter.style.display = 'block';

    let html = '';
    cart.items.forEach(item => {
      // Collect custom line-item properties
      let propsHtml = '';
      if (item.properties) {
        const entries = Array.isArray(item.properties) ? item.properties : Object.entries(item.properties);
        entries.forEach(([key, val]) => {
          if (!key || !val || String(key).charAt(0) === '_') return;
          propsHtml += `<div class="cart-item-prop"><span class="cart-item-prop-label">${escapeHtml(key)}:</span> <span class="cart-item-prop-value">${escapeHtml(String(val))}</span></div>`;
        });
      }

      html += `
        <div class="cart-item" data-line="${item.key}">
          <div class="cart-item-image">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="cart-item-details">
            <div class="cart-item-title">${item.product_title}</div>
            <div class="cart-item-variant">${item.variant_title || ''}</div>
            ${propsHtml}
            ${duoNote(item) ? `<div class="cart-item-duo">${duoNote(item)}</div>` : ''}
            <div class="cart-item-qty">
              <button onclick="soma.changeQty('${item.key}', ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button onclick="soma.changeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-remove" onclick="soma.changeQty('${item.key}', 0)">
              ${window.somaStrings?.remove || 'Entfernen'}
            </div>
          </div>
          <div class="cart-item-price">
            ${item.original_line_price > item.final_line_price ? `<span class="cart-item-price-old">${formatMoney(item.original_line_price)}</span>${formatMoney(item.final_line_price)}` : formatMoney(item.final_line_price)}
          </div>
        </div>`;

    });

    // Upsell — show cached upsell if product not already in cart
    if (upsellHtmlCache && upsellProductIdCache) {
      const alreadyInCart = cart.items.some(item => item.product_id === upsellProductIdCache);
      if (!alreadyInCart) {
        html += upsellHtmlCache;
      }
    }

    cartBody.innerHTML = html;

    // Update totals
    const cartFooterEl = document.querySelector('.cart-drawer-footer');
    if (cartFooterEl) {
      const hasDiscount = cart.total_discount > 0;
      // Bezeichnung aller Rabatte: Warenkorb-Rabatte + Produkt-Rabatte (z. B. "SOMA Duo-Set")
      const discountTitles = new Set();
      (cart.cart_level_discount_applications || []).forEach(d => { if (d.title) discountTitles.add(d.title); });
      cart.items.forEach(item => (item.line_level_discount_allocations || []).forEach(a => {
        if (a.discount_application && a.discount_application.title) discountTitles.add(a.discount_application.title);
      }));
      const discountTitle = escapeHtml([...discountTitles].join(', ') || 'Rabatt');

      let totalsHtml = '';
      if (hasDiscount) {
        totalsHtml += `<div class="cart-totals cart-totals--original"><span class="total-label">Zwischensumme</span><span class="total-price-original">${formatMoney(cart.original_total_price)}</span></div>`;
        totalsHtml += `<div class="cart-totals cart-totals--discount"><span class="total-label">${discountTitle}</span><span class="total-discount-amount">-${formatMoney(cart.total_discount)}</span></div>`;
      }
      totalsHtml += `<div class="cart-totals"><span class="total-label">${hasDiscount ? 'Gesamt' : (window.somaStrings?.subtotal || 'Zwischensumme')}</span><span class="total-price">${formatMoney(cart.total_price)}</span></div>`;

      const shippingNote = cartFooterEl.querySelector('.cart-shipping-note');
      const existingTotals = cartFooterEl.querySelectorAll('.cart-totals');
      existingTotals.forEach(el => el.remove());
      if (shippingNote) {
        shippingNote.insertAdjacentHTML('beforebegin', totalsHtml);
      }
    }
  }

  function changeQuantity(lineKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
    .then(response => response.json())
    .then(cart => {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
    })
    .catch(error => console.error('Cart change error:', error));
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* --- Upsell Button Handler --- */
  document.addEventListener('click', (e) => {
    const upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      const upsellWrap = upsellBtn.closest('.cart-upsell');
      if (!upsellWrap) return;
      const variantId = upsellWrap.dataset.upsellVariant;
      if (!variantId) return;

      upsellBtn.disabled = true;
      upsellBtn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(r => r.json())
      .then(() => updateCartDrawer())
      .catch(err => {
        console.error('Upsell add error:', err);
        upsellBtn.disabled = false;
        upsellBtn.textContent = window.somaStrings?.upsellButton || 'Hinzufügen';
      });
    }
  });

  /* --- Add to Cart Button Handlers --- */
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.variantId;
      if (variantId) {
        addToCart(variantId, parseInt(addBtn.dataset.quantity) || 1);
      }
    }
  });

  /* --- Sticky Mobile CTA --- */
  const stickyCta = document.querySelector('.sticky-mobile-cta');
  const heroSection = document.querySelector('.hero');
  if (stickyCta && heroSection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(heroSection);
  }

  /* --- Scroll Reveal Animations --- */
  const revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    revealElements.forEach(el => revealObserver.observe(el));
  }

  /* --- Warenkorb-Seite (/cart): Duo-Hinweise aus /cart.js ergänzen --- */
  const cartPageLines = document.querySelectorAll('[data-cart-page-line]');
  if (cartPageLines.length) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          const note = duoNote(item);
          const el = document.querySelector(`[data-cart-page-line="${item.key}"] [data-duo-note]`);
          if (el && note) { el.innerHTML = note; el.hidden = false; }
        });
      })
      .catch(() => {});
  }

  /* --- Eingefügte Texte aufräumen (Rechtstexte /policies/*, Produktbeschreibung) ---
     Fett gesetzte Einzelzeilen werden zu Zwischenüberschriften, doppelte Zeilenumbrüche
     zu einem Absatz-Abstand, leere Absätze entfallen (die Abstände regelt das CSS). */
  function tidyRichText(root, headingClass, gapClass) {
    root.querySelectorAll('p').forEach(p => {
      const text = p.textContent.replace(/\u00a0/g, ' ').trim();
      if (!text && !p.querySelector('img, iframe, table, video')) {
        p.remove();
        return;
      }
      const only = p.firstElementChild;
      if (p.childElementCount === 1 && only && /^(STRONG|B)$/.test(only.tagName) &&
          text === only.textContent.replace(/\u00a0/g, ' ').trim() && text.length <= 120) {
        p.classList.add(headingClass);
      }
    });
    root.querySelectorAll('br').forEach(br => {
      if (!br.isConnected) return;
      let next = br.nextSibling;
      while (next && next.nodeType === 3 && !next.textContent.trim()) next = next.nextSibling;
      if (next && next.nodeName === 'BR') {
        const gap = document.createElement('span');
        gap.className = gapClass;
        next.replaceWith(gap);
      }
    });
  }
  document.querySelectorAll('.shopify-policy__body').forEach(el => tidyRichText(el, 'policy-heading', 'policy-gap'));
  document.querySelectorAll('.pd__desc').forEach(el => tidyRichText(el, 'pd__desc-heading', 'pd__desc-gap'));

  /* --- Expose global API --- */
  window.soma = {
    addToCart: addToCart,
    openCart: openCart,
    closeCart: closeCart,
    changeQty: changeQuantity,
    updateCartDrawer: updateCartDrawer
  };

  /* --- Initialize --- */
  document.addEventListener('DOMContentLoaded', () => {
    updateCartDrawer();

  });

})();
